/**
 * frontend/src/pages/BrowsePage.js
 * Main corpus browse — mirrors mobile app home screen exactly.
 */
import { useNavigate } from 'react-router-dom';
import { TAXONOMY, getAvailableCount } from '../data/taxonomy';
import styles from './BrowsePage.module.css';

export default function BrowsePage() {
  const navigate = useNavigate();

  return (
    <div className={styles.page}>
      <header className={styles.header}>
        <div className={styles.headerTitle}>
          <span className={styles.titleIast}>महावाक्य</span>
          <span className={styles.titleDevanagari}></span>
        </div>
        <p className={styles.subtitle}>Classical Verse · Semantic Search</p>
        <div className={styles.divider} />
      </header>

      <div className={styles.categoryList}>
        {TAXONOMY.map((cat) => {
          const availCount = getAvailableCount(cat);
          return (
            <button
              key={cat.id}
              className={`${styles.categoryCard} ${!cat.available ? styles.dimmed : ''}`}
              style={{ '--cat-color': cat.color, '--cat-color-light': cat.colorLight }}
              onClick={() => navigate(`/browse/${cat.id}`)}
            >
              <div className={styles.cardInner}>
                <div className={styles.cardText}>
                  <span className={styles.cardDevanagari}>{cat.label}</span>
                  <span className={styles.cardIast}>{cat.labelIast}</span>
                  <span className={styles.cardDesc}>{cat.description}</span>
                </div>
                <div className={styles.cardFooter}>
                  {!cat.available ? (
                    <span className={styles.badgeComingSoon}>Coming soon</span>
                  ) : (
                    <>
                      <span className={styles.badgeAvailable}>{availCount} available</span>
                      <span className={styles.arrow}>→</span>
                    </>
                  )}
                </div>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
